import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Avatar } from 'antd';

// icons
import { UserOutlined } from '@ant-design/icons';

// global user
import { withUser } from 'engine/Contexts/User.context';

function UserAvatar({ view, user, width, height, fontSize, className, ...rest }) {
  const childClassNames = classNames('user-photo', view, className);
  const defWidth = width ? width : 65;
  const defHeight = height ? height : 65;
  const defFontSize = fontSize ? fontSize : 16;

  const userInitials =
      user.description?.firstname &&
      user.description?.lastname &&
      user.description?.firstname.charAt(0) +
        user.description?.lastname.charAt(0),
    userDefImage = (
      <span
        style={{
          width: `${defWidth}px`,
          minWidth: `${defWidth}px`,
          height: `${defHeight}px`,
          fontSize: `${defFontSize}px`,
        }}
        className="emptyImage"
      >
        {userInitials}
      </span>
    );

  let firstName = user?.description?.firstname;
  if (user?.description?.firstname?.includes(" ")) {
    const arr = user?.description?.firstname?.split(" ");
    const [name, name2, ...rest] = arr;
    firstName = `${!!name ? name : ""}${!!name2 ? ` ${name2}`:""}`
  }
  
  return (
    user && (
      <div className={childClassNames}>
        {user?.image ? (
          <Avatar className="photo" size={defWidth} src={user.image} />
        ) : user?.description?.firstname && user?.description?.lastname ? (
          userDefImage
        ) : (
          <Avatar className="photo" size={defWidth} icon={<UserOutlined />} />
        )}
        {view == 'small' && (<>
          {user?.description?.firstname && (
            <span className="info-name info-name--small">{firstName}</span>
          )}
        </>)}
        {view == 'full' && (<>
          {user?.description?.firstname && user?.description?.lastname && (
            <span className="info-name info-name--full">{firstName} {user?.description?.lastname}</span>
          )}
        </>)}
      </div>
    )
  );
}

UserAvatar.defaultProps = {
  view: 'avatar'
};
UserAvatar.propTypes = {
  view: PropTypes.oneOf(['full', 'small', 'avatar']).isRequired,
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default compose(
  memo,
  withUser
)(UserAvatar);
